import React, { useState } from 'react'
import { debounce } from 'lodash'
import { ComboBox, NoOptionFound } from '@rodeo-dev/legos'
import IntlUtil from '../../../lib/intlutil.jsx'

export const ClientSearch = ({
  clientList,
  onClientSelect,
  onCreateNewClient,
  error
}) => {
  const [typedClientName, setTypedClientName] = useState(null)
  const handleClientSelect = (e, client) => {
    onClientSelect(client)
  }
  return (
    <ComboBox
      label={IntlUtil.convertMessage('project.create.selectClient')}
      fullWidth
      options={clientList}
      getOptionLabel={(option) => option.name}
      onChange={handleClientSelect}
      onInputChange={debounce((e, value) => setTypedClientName(value), 250)}
      inputProps={{
        error: !!error,
        helperText: error,
        required: true
      }}
      noOptionsText={
        <NoOptionFound
          headerLabel={IntlUtil.convertMessage(
            'project.create.notFoundOptionHeaderLabel'
          )}
          subHeaderLabel={IntlUtil.convertMessage(
            'project.create.notFoundOptionSubHeaderLabel'
          )}
          onButtonClick={() => onCreateNewClient(typedClientName)}
          buttonLabel={IntlUtil.convertMessage(
            'project.create.notFoundOptionButtonLabel'
          )}
          withButton
        />
      }
    />
  )
}
